export default __webpack_public_path__ + "static/how-to-maximise-a-short-annual-leave-holiday-42021a2fafa6f5e1524c14f195c20caa.jpg";